import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import withData from '@bd/bdcore-data';
import { css } from '@bd/bdui-styles/emotion';
// import { Link } from '@bd/bdcore-named-routes';
import PageSectionHeading from '../../PageSectionHeading';
import HomeCardElliottReserve from '../../HomeCardElliottReserve';

const styles = css`
  padding: 0;
  position: relative;
  z-index: 2;
  @media(min-width: 992px) {
    padding: 120px 0;
  }
  .CardContainer {
    width: 100%;
    margin: 0 auto 15px auto;
    overflow-x: scroll;
    -webkit-overflow-scrolling: touch;
    clip-path: inset(0 0 30px 0); /* hide scroll bar on mobile */
  }
  .CardRow {
    display: flex;
    flex-direction: row;
    white-space: nowrap;
    flex-wrap: nowrap;
    justify-content: center;
    padding: 0 30px;
    width: fit-content;
    min-width: 100vw;
  }
`;


class FeaturedProducts extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tab: undefined,
    };
  }

  switchTabHandler = tab => {
    this.setState({
      tab,
    });
  }

  render() {
    const { homes, communities, content } = this.props;
    const reservedCommunities = communities
      .filter(community => community.elliott_reserve_community)
      .map(community => community._id);
    return (
      <div className={styles}>
        <PageSectionHeading h3={get(content, '[0].homes_heading')} underdog />
        <div className="ContentWrapper">
          <div>
            <div className="CardContainer">
              <div className="CardRow">
                {
                  homes.filter(home => reservedCommunities.includes(home.containedIn)).map(home => (
                    <HomeCardElliottReserve
                      home={home}
                      key={home._id}
                      hideCommunity
                      hideFloorplan
                      hideLot
                    />
                  ))
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}


FeaturedProducts.propTypes = {
  content: PropTypes.arrayOf(PropTypes.object).isRequired,
  homes: PropTypes.arrayOf(PropTypes.object).isRequired,
  communities: PropTypes.arrayOf(PropTypes.object).isRequired,
};

FeaturedProducts.defaultProps = {
};

export default withData({
  areas: 'all',
  homes: 'all',
  communities: 'all',
})(FeaturedProducts);



// WEBPACK FOOTER //
// ./src/components/PageLoader/Sections/FeatureProductElliottReserve.section.js